import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "bar theme-d2 left-align large" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bars" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "bar-item button padding-large theme-d4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home margin-right" }),
  /*#__PURE__*/_createTextVNode("System Monitor")
], -1)
const _hoisted_6 = {
  id: "navDemo",
  class: "bar-block theme-d2 hide large",
  style: {"margin-top":"50px"}
}
const _hoisted_7 = {
  class: "white",
  style: {"margin-bottom":"1em"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-square fa-fw margin-right" }, null, -1)
const _hoisted_9 = {
  class: "hide container",
  id: "addDevice"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search-plus" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: "bar-item button right padding-large hover-white large theme-d2",
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.openNav()))
        }, _hoisted_4),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.myFunction('addDevice'))),
          class: "button block theme-l1 left-align"
        }, [
          _hoisted_8,
          _createTextVNode("Add Device ")
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "border padding",
            style: {"width":"100%"},
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.coreid) = $event))
          }, null, 512), [
            [_vModelText, $data.coreid]
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.addCore($data.coreid))),
              class: "button theme",
              style: {"width":"100%"}
            }, [
              _hoisted_10,
              _createTextVNode("  Search ")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}